import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import {combineLatest, map, Observable} from 'rxjs';
import {UserHttpService} from "../services/user-http.service";
import {UserService} from "../services/user.service";

@Injectable({
  providedIn: 'root'
})
export class CguGuard implements CanActivate {

  constructor(private router: Router, private cguService: UserHttpService , private userService : UserService ) {
  }


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean  {
    console.log('cguGaurd : canMAtch');
    return combineLatest([
      this.cguService.getUserCGU(),
      this.userService.terms
    ]).pipe(
      map(([cguData, termsAccepted]) => {
        if (cguData || termsAccepted) {
          return true;
        } else {
          this.router.navigate(['/CGUser']);
          return false;
        }
      })
    );
  }

}
